export const TIMECODE_DIGIT_OPTIONS = {
    length: 8,
    maxValues: [undefined, undefined, 5, 9, 5, 9, 2, 9],
    separators: { 1: ':', 3: ':', 5: ':' },
};

export const DURATION_DIGIT_OPTIONS = {
    length: 6,
    maxValues: [undefined, undefined, 5, 9, 5, 9],
    separators: { 1: ':', 3: ':' },
};

export const TARGET_FORMAT_OPTIONS = [
    { label: 'Prores 4444 XQ', value: 'prores_4444_xq' },
    { label: 'Prores 444', value: 'prores_444' },
    { label: 'Prores 422 HQ', value: 'prores_422_hq' },
    { label: 'Prores Proxy', value: 'prores_proxy' },
    { label: 'XDCAM HD 50', value: 'xdcam_hd_50' },
    { label: 'IMX 30', value: 'imx_30' },
    { label: 'IMX 50', value: 'imx_50' },
    { label: 'H264 3 Mbps mp4', value: 'h264_3_mp4' },
    { label: 'H264 5 Mbps mp4', value: 'h264_5_mp4' },
    { label: 'H264 15 Mbps mp4', value: 'h264_15_mp4' },
    { label: 'H264 3 Mbps mov', value: 'h264_3_mov' },
    { label: 'H264 5 Mbps mov', value: 'h264_5_mov' },
    { label: 'H264 15 Mbps mov', value: 'h264_15_mov' },
];

export const CADENCE_OPTIONS = [
    { label: '23,976', value: '23.976' },
    { label: '24', value: '24' },
    { label: '25', value: '25' },
    { label: '29,97', value: '29.97' },
    { label: '30', value: '30' },
    { label: '50', value: '50' },
    { label: '59,94', value: '59.94' },
    { label: '60', value: '60' },
];
